import styled from 'styled-components';
import { useTimeout } from '../../../hooks/timeout/useTimeout';
import { Icon } from '../../common/icon/Icon';

interface ToastProps {
  close: () => void;
  children: string;
}

export const Toast = ({ close, children }: ToastProps) => {
  useTimeout(close, 2300);

  return (
    <div className={'fixed top-[45%] left-1/2 transform -translate-x-1/2 -translate-y-1/2'} style={{ zIndex: 250 }}>
      <ToastContainer className={'toast shadow'}>
        <ToastText className={'toast__text'}>{children}</ToastText>
        <ToastBtn onClick={close} className={'toast__close-btn'}>
          <Icon name={'ImgDel'} width={12} height={12} />
        </ToastBtn>
      </ToastContainer>
    </div>
  );
};

const ToastContainer = styled.div`
  border: 2px solid transparent;
  background: rgba(0, 0, 0, 0.6);
  color: white;
  backdrop-filter: blur(2px);
  border-radius: 16px;
  max-width: '100%';
  margin-top: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: 4px 8px;
  cursor: pointer;
  z-index: 250;
`;

const ToastText = styled.div`
  width: 100%;
  padding: 8px 0px;
  padding-left: 12.5px;
  line-height: 1.4;
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  white-space: pre;
`;

const ToastBtn = styled.button`
  width: 20px;
  border: none;
  background-color: transparent;
  font-size: 16px;
  margin: 2px 8px;
  cursor: pointer;

  display: flex;
  align-items: center;
  justify-content: center;
`;
